const REDUX_OPTION = {
  KEYS_TO_VALIDATE: 'keysToValidate',
  KEYS_TO_KEEP: 'keysToKeep',
  FORCED: 'isForced',
  RESETTING: 'isResetting',
  MERGE: 'isMerge',
  OMIT_STATUS: 'shouldOmitStatus',
  IS_FORCED: 'isForced',
  IS_IMMEDIATE: 'isImmediate',
  IGNORE_UPDATED_AT: 'ignoreUpdatedAt',
  NO_AUTH_NEEDED: 'noAuthNeeded',
  OMIT_SUCCESS_STATUS_BATCH_SIZE: 'omitSuccessStatusBatchSize',
  MIN_BATCH_SIZE: 'minBatchSize',
  OMIT_EDITING: 'shouldOmitEditing',
  RESET_CHANGED: 'resetChanged',
  SHALLOW_PARSING: 'isShallowParsing',
  SHOULD_HIDE_BANNER: 'shouldHideBanner',
  SET_ALIAS: 'shouldSetAlias',
  SHOULD_KEEP_PATH: 'shouldKeepPath'
}
export default REDUX_OPTION
